import localeTr from '@angular/common/locales/tr';
import localeTrExtra from '@angular/common/locales/extra/tr';

import { LanguageEnum, Language } from '../core/interfaces/language-types';

export default class TurkishLanguage extends Language {
  protected locale = localeTr;
  protected localeExtra = localeTrExtra;
  protected details = {
    image: 'images/flags/tr.png',
    title: 'Turkish',
    enum: LanguageEnum.Turkish,
    aira: 'Turkish Selected',
    select: 'Choose Turkish Language',
    abre: 'tr'
  };
}
